namespace Matrix.Rebalancer {
    export namespace TradeMacroStepService {
        export const baseUrl = 'Rebalancer/TradeMacroStep';

        export declare function Create(request: Serenity.SaveRequest<TradeMacroStepRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<TradeMacroStepRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<TradeMacroStepRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<TradeMacroStepRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Rebalancer/TradeMacroStep/Create",
            Update = "Rebalancer/TradeMacroStep/Update",
            Delete = "Rebalancer/TradeMacroStep/Delete",
            Retrieve = "Rebalancer/TradeMacroStep/Retrieve",
            List = "Rebalancer/TradeMacroStep/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>TradeMacroStepService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
